"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var bannerZoneServices_service_1 = require("./../Services/bannerZoneServices.service");
var rxjs_1 = require("rxjs");
var router_1 = require("@angular/router");
var action_service_1 = require("./action.service");
var service_service_1 = require("../Services/service.service");
var AppMobileComponent = /** @class */ (function () {
    function AppMobileComponent(router, _actionService, mainService, bannersService) {
        this.router = router;
        this._actionService = _actionService;
        this.mainService = mainService;
        this.bannersService = bannersService;
        this.title = 'WickedMobile';
        this.openedSubject = new rxjs_1.Subject();
        this.sideNavDisplay = true;
    }
    AppMobileComponent.prototype.ngOnInit = function () {
        this.bannersService.getAllUserBaners(1);
    };
    AppMobileComponent.prototype.dismissSidenav = function (data) {
        this._actionService.sideNavDisplayChange(data);
    };
    return AppMobileComponent;
}());
exports.AppMobileComponent = AppMobileComponent;
